import { useTranslation } from 'react-i18next';

import { Button } from '@/components/atoms/Buttons';
import { confirm } from '@/components/molecules/ConfirmDialog';

interface DeleteUserButtonProps {
    deleteUser: (id: number) => Promise<unknown>;
    id: number;
}

export function DeleteUserButton({ deleteUser, id }: DeleteUserButtonProps) {
    const { t } = useTranslation();

    return (
        <Button
            variant="danger"
            trackingId="user_table_delete"
            onClick={(e) => {
                e.preventDefault();
                confirm({
                    title: t('userAccess.common.deleteUser'),
                    message: t('userAccess.userRowButtons.areYouSureYouWant'),
                    confirmLabel: t('common.actions.delete'),
                    errorFallback: t('userAccess.deleteFailed'),
                    onConfirm: () => deleteUser(id),
                });
            }}>
            {t('userAccess.common.deleteUser')}
        </Button>
    );
}

interface ImpersonateUserButtonProps {
    impersonateUser: (id: number) => Promise<unknown>;
    id: number;
}

export function ImpersonateUserButton({ impersonateUser, id }: ImpersonateUserButtonProps) {
    const { t } = useTranslation();

    return (
        <Button
            variant="secondary"
            trackingId="user_table_impersonate"
            onClick={async (e) => {
                e.preventDefault();
                await impersonateUser(id);
            }}>
            {t('userAccess.loginAsUser')}
        </Button>
    );
}
